$(document).ready(function() {
  featuredCollectionSlider();
});

$(window).resize(function() {
  featuredCollectionSlider();
});

// $(document).scroll(function() {
//     console.log("");
// });
// $(window).scrollTop(function(){
//   	console.log("top");
// });

// $(window).scroll(function() {
//     if ($(this).scrollTop() > 0){  
//       console.log("top");
// 		 $('header').addClass("sticky");
      
//     }
//     else{
// 		 $('header').removeClass("sticky");
//       console.log("bottom");
//     }
// });

function featuredCollectionSlider() {
  if($(window).width() < 767) {
    $('.featured-collection-slider').slick({
      dots: true,
      infinite: true,
//       arrows: true,
      speed: 450,
      slidesToShow: 1,
      slidesToScroll: 1
    }); 
  } else {
    $('.featured-collection-slider').slick('unslick');
  }
}

$("#Hero-slideshow").click(function(){
  window.location.href='collections/all';
});
$("#Hero-16431926393a6d73ef").click(function(){
  window.location.href='collections/all';
});
